import { render, staticRenderFns } from "./important.vue?vue&type=template&id=0492889c"
import script from "./important.vue?vue&type=script&lang=js"
export * from "./important.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports